import Card from '@/components/card';
import FormSection from '@/components/form/form-section';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModelV1 } from '@/lib/models/policy-model-v1/policy-v1.model';
import { FC, useMemo } from 'react';
import { ContentControlSettings } from '@/lib/models/policy-model-v1/content-controls';
import ContentControlItemV1 from './item';
import FormSectionSubtitle from '@/components/form/form-section/form-section-subtitle';

interface Props {
  policy: PolicyModelV1;
  orgPolicy?: PolicyModelV1;
  formHandle: FormHandle<PolicyModelV1>;
  readonly: boolean;
}

const ContentControlsV1: FC<Props> = ({ formHandle, readonly, policy, orgPolicy }) => {
  // File uploads is managed in the service access tab
  const availableControls = useMemo(() => {
    return ContentControlSettings.filter(({ type }) => type !== 'file-upload');
  }, []);

  return (
    <FormSection title="Content Controls" scrollId="content-controls">
      <FormSectionSubtitle>
        For each content type below, choose the action to take when that type is detected in the
        request.
      </FormSectionSubtitle>
      <Card>
        {availableControls.map(({ type: settingType }) => {
          return (
            <ContentControlItemV1
              key={`content-control-${settingType}`}
              controlType={settingType}
              formHandle={formHandle}
              readonly={readonly}
              policy={policy}
              orgPolicy={orgPolicy}
            />
          );
        })}
      </Card>
    </FormSection>
  );
};

export default ContentControlsV1;
